import { Configuration } from '~/core/configuration/configuration.type';

export interface LoadModulesParams {
    config: Configuration;
    debug: boolean;
}

/**
 * Asynchronously loads independent modules
 * should not return anything & should not throw any errors (independent modules should not affect the main application in any way)
 */
export const loadIndependentPlugins = ({ config, debug }: LoadModulesParams): void => {
    (async () => {
        try {
            if (!config.layout.configuration.forbidGoogleAnalytics) {
                // Load Google Analytics
                await import(
                    /* webpackChunkName: "module-google-analytics" */ '~/analytics/GoogleAnalytics/GoogleAnalytics'
                )
                    .then(({ GoogleAnalytics }) => {
                        try {
                            new GoogleAnalytics();
                        } catch (error) {
                            if (debug) {
                                console.error('SEARCH READY ERROR: Google Analytics module initialization failed');
                                console.error(error);
                            }
                        }
                    })
                    .catch((error) => {
                        if (debug) {
                            console.error('SEARCH READY ERROR: Google Analytics module loading failed');
                            console.error(error);
                        }
                    });
            }
            if (!config.layout.configuration.forbidActionAnalytics) {
                // Load Action Analytics
                await import(
                    /* webpackChunkName: "module-action-analytics" */ '~/analytics/ActionAnalytics/ActionAnalytics'
                )
                    .then(({ ActionAnalytics }) => {
                        new ActionAnalytics(config.apiUrl, config.serpId);
                    })
                    .catch((error) => {
                        if (debug) {
                            console.error('SEARCH READY ERROR: Action Analytics module loading failed');
                            console.error(error);
                        }
                    });
            }
        } catch (error) {
            if (debug) {
                console.error('SEARCH READY ERROR: error while fetching modules');
                console.error(error);
            }
        }
    })();
};
